import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bms',
  templateUrl: './bms.component.html',
  styleUrls: ['./bms.component.css']
})
export class BmsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
